import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
export default{
    components: {
        Bar
    },
    data(){
        return{
            dashboardXData: [],
            dashboardYData: [],
            chartOptions: {
                responsive: true
              },
              noData:{
                id: 'noData',
                afterDatasetsDraw: ((chart, args, plugins) => {
                    const {ctx, data, chartArea: {top, bottom, left, right, width, height}} = chart;
                    ctx.save();
                    ctx.fillStyle = 'rgba(102, 102, 102, 0.5)';
                    ctx.fillRect(left,top,width,height);
                    ctx.font = '16px sans-serif';
                    ctx.fillStyle = 'black';
                    ctx.textAlign = 'center';
                    ctx.fillText('Период не выбран, либо нет данных', left + width/2, top + height/2);
                })
              }
        }
    },
}